var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.remarkLoading,
              expression: "remarkLoading",
            },
          ],
          attrs: {
            "close-on-click-modal": false,
            title: _vm.title,
            visible: _vm.visible,
            width: "710px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "12px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 18 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        "popper-append-to-body": false,
                        filterable: "",
                        placeholder: "常用备注选择",
                        clearable: true,
                      },
                      on: { change: _vm.updateRemark },
                      model: {
                        value: _vm.sellerWordsInfoTemp,
                        callback: function ($$v) {
                          _vm.sellerWordsInfoTemp = $$v
                        },
                        expression: "sellerWordsInfoTemp",
                      },
                    },
                    _vm._l(_vm.remarkData, function (item, key) {
                      return _c(
                        "el-option",
                        {
                          key: key,
                          attrs: { label: item.contents, value: item.contents },
                        },
                        [
                          _c("div", [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  float: "left",
                                  width: "87%",
                                  oveflow: "hidden",
                                  "text-overflow": "ellipsis",
                                  overflow: "hidden",
                                },
                                attrs: { title: item.contents },
                              },
                              [_vm._v(_vm._s(item.contents))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "y-ml-20",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.deleteRemark(_vm.remarkData[key])
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.showRemarkDialog()
                        },
                      },
                    },
                    [_vm._v("添加自定义备注")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "editSellerRemarkForm",
              attrs: { "label-width": "0px", model: _vm.currentRow },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 6, maxRows: 10 },
                      maxlength: "100",
                      "show-word-limit": "",
                      placeholder: "请输入备注，100字以内",
                    },
                    model: {
                      value: _vm.currentRow.mallRemark,
                      callback: function ($$v) {
                        _vm.$set(_vm.currentRow, "mallRemark", $$v)
                      },
                      expression: "currentRow.mallRemark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveInfo } },
                [_vm._v("保存")]
              ),
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加备注",
            center: "",
            visible: _vm.remarkdialogFormVisible,
            width: "40%",
            "before-close": _vm.resetRemarkForm,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.remarkdialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "remarkForm",
              attrs: {
                model: _vm.remarkForm,
                prop: "remark",
                rules: _vm.remarkFormRule,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "备注内容", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 6, maxRows: 10 },
                      autocomplete: "off",
                      maxlength: "100",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.remarkForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.remarkForm, "remark", $$v)
                      },
                      expression: "remarkForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitRemarkFn },
                },
                [_vm._v("确 定")]
              ),
              _c("el-button", { on: { click: _vm.resetRemarkForm } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }